import { useMemo } from "react";
import { Col, Row, Card, CardBody, CardHeader } from "reactstrap";
import TableContainerMin from "../../../../Components/Common/TableContainerMin";
import { useQuery } from "react-query";
import { Button, Spin } from "antd";
import { Link } from "react-router-dom";
import { getDemandeMateriels } from "../../../Materiels/services/materielApi";
import { formatCriticity, formatState, getCriticityColor, getStateColor } from "../../../../Components/Common/FormatDate/formatStatus";
const DemandesDashbord = () => {

  const { data: demandeMaterials, isLoading, isError, error } = useQuery("demandes", getDemandeMateriels);
  console.log('demandeMaterials', demandeMaterials)

  const columns = useMemo(
      () => [      
        { Header: "Numero", accessor: "requestNumber", filterable: false },
        { Header: "Demande", accessor: "name", filterable: false },
        { Header: "Technicien",
          accessor: "technician",
          Cell: ({ value }) => value ? `${value?.name || ''} ${value?.phone || ''}`.trim() : "-",
          filterable: false 
        },
        // { 
        //   Header: "Date", 
        //   accessor: "createdAt",
        //   Cell: ({ value }) => formatDate(value, true),
        //   filterable: false,        
        // },
        {
          Header: "Criticité",
          accessor: "level",
          Cell: ({ value }) => (
            <span
              className={`badge bg-${getCriticityColor(value)}-subtle text-${getCriticityColor(value)}`}
            >
              {formatCriticity(value)}
            </span>
          ),
          filterable: false,
        },
        {
          Header: "Statut",
          accessor: "status",
          Cell: ({ value }) => (
            <span
              className={`badge bg-${getStateColor(value)}-subtle text-${getStateColor(value)}`}
            >
              {formatState(value)}
            </span>
          ),
          filterable: false,
        },
      ],
      []
    );

  return (
    <Row>
      <Col>
        <Card id="contactList">
          <CardHeader
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>Les cinq dernières demandes</span>
            <div>
              <Link to="/demandes-materiels" style={{ marginRight: "10px" }}>
                <Button className="btn btn-soft-success">Voir tous</Button>
              </Link>
            </div>
          </CardHeader>
          <CardBody className="pt-0" style={{ height: "375px", overflowY: "auto" }}>
            <TableContainerMin
              columns={columns}
              data={demandeMaterials?.slice(-5) || []}
              customPageSize={5}
              className="custom-header-css"
              divClass="table-responsive table-card mb-3"
              tableClass="align-middle table-nowrap"
              theadClass="table-light"
            />
            {isLoading && !isError && (
              <div className="text-center">
                Chargement, Merci de patienter ... <Spin />
              </div>
            )}
            {isError && (
              <div className="text-center">
                Erreur lors du chargement des données :{" "}
                {error?.message || error}
              </div>
            )}
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default DemandesDashbord;
